import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { CommonSelectListService } from '../../service/common-select-list.service';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { BranchModel } from '../../../modules/branch/model/branch-model';
import { ModuleParamCBLModel } from '../modal/module-param-cblmodel';
import { LocationMasterModel } from '../../../modules/location/model/location-master-model';
import { OrgProfileService } from '../../../modules/org-profile/service/org-profile.service';
import { PartyModal } from '../../../modules/party/modal/party-modal';
import { OrgProfileModal } from '../../../modules/org-profile/modal/org-profile-modal';

@Component({
  selector: 'app-party-cbl',
  templateUrl: './party-cbl.component.html',
  styleUrls: ['./party-cbl.component.css'],
})
export class PartyCBLComponent extends AbstractBaseDetailsComponent implements OnInit, OnChanges {
  partyFormGroup: FormGroup;
  moduleParamModel: ModuleParamCBLModel = new ModuleParamCBLModel(this.moduleParamConfigGlob);
  @Input() submitted: boolean;
  @Input() isUpdateComponent: boolean;

  @Input() branchList: Array<BranchModel> = new Array<BranchModel>();
  @Input() selectedParty: PartyModal;

  @Input() selectedPartyCompany: OrgProfileModal;
  @Input() selectedPartyBranch: BranchModel = new BranchModel();
  @Input() selectedPartyLocation: LocationMasterModel;

  constructor(
    public toaster: ToastrService,
    private moduleParamConfigGlob: ModuleParamGlobConfigService,
    private formBuilder: FormBuilder,
    private orgService: OrgProfileService,
    private commonService: CommonSelectListService
  ) {
    super(toaster);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isUpdateComponent) {
      if (changes && changes.selectedParty && changes.selectedParty.currentValue) {
        this.getBranchListOnUpdate(changes.selectedParty.currentValue);
      }
    }
  }

  ngOnInit() {
    this.setValidation();
  }

  /** Form Validation **/
  private setValidation() {
    this.partyFormGroup = this.formBuilder.group({
      partyBranch: [],
    });
    this.utilConfigCheckFormValidation(
      this.partyFormGroup,
      'partyBranch',
      this.moduleParamModel.partyCbl.partyBranch.isRequired
    );
  }

  get f() {
    return this.partyFormGroup.controls;
  }

  utilConfigCheckFormValidation(formGroup: FormGroup, name: string, required: boolean) {
    formGroup.get(`${name}`).clearValidators();
    if (required) formGroup.get(`${name}`).setValidators([Validators.required]);
    formGroup.get(`${name}`).updateValueAndValidity();
  }
  /** Form Validation **/

  onSelectPartyBranch() {
    this.selectedPartyLocation = new LocationMasterModel();
    if (this.selectedPartyBranch) {
      let selectedBr = this.selectedPartyCompany.branchDetails.find(
        (br) => br.branch.id === this.selectedPartyBranch.id
      );
      this.selectedPartyLocation = selectedBr.branchDetailsLocation.find((loc) => loc.isDefault).location;
    }
  }

  getBranchList(event: PartyModal) {
    this.branchList = new Array<BranchModel>();
    this.selectedPartyCompany = undefined;
    this.selectedPartyBranch = undefined;
    if (event) {
      if (event.owningCompany) {
        this.orgService.getById(event.owningCompany).subscribe((response) => {
          this.validateResponse(response, () => {
            this.selectedPartyCompany = new OrgProfileModal();
            this.selectedPartyCompany = response.data;
            if (this.selectedPartyCompany.branchDetails && this.selectedPartyCompany.branchDetails.length !== 0) {
              this.branchList = this.selectedPartyCompany.branchDetails.map((ls) => ls.branch);
              let selectedCmp = this.selectedPartyCompany.branchDetails.find((br) => br.isDefault);
              this.selectedPartyBranch = new BranchModel();
              this.selectedPartyBranch = selectedCmp.branch;
              if (selectedCmp.branchDetailsLocation && selectedCmp.branchDetailsLocation.length !== 0)
                this.selectedPartyLocation = selectedCmp.branchDetailsLocation.find((lc) => lc.isDefault).location;
            }
          });
        });
      }
    }
  }

  getBranchListOnUpdate(event: PartyModal) {
    this.branchList = new Array<BranchModel>();
    if (event) {
      if (event.owningCompany) {
        this.orgService.getById(event.owningCompany).subscribe((response) => {
          this.validateResponse(response, () => {
            if (
              this.selectedPartyCompany &&
              this.selectedPartyCompany.branchDetails &&
              this.selectedPartyCompany.branchDetails.length !== 0
            )
              this.branchList = this.selectedPartyCompany.branchDetails.map((ls) => ls.branch);
          });
        });
      }
    }
  }
}
